export default __webpack_public_path__ + "static/media/1.63cb59fc.png";